import './CancelConfirmModal.scss';

import React from 'react'
import ReactDOM from 'react-dom'
export interface CancelConfirmModalProps {
  message: string
  subtext?: string
  yesLabel: string
  noLabel: string
  onConfirm: () => void
  onDismiss: () => void
}

const CancelConfirmModal: React.FC<CancelConfirmModalProps> = ({
  message,
  subtext,
  yesLabel,
  noLabel,
  onConfirm,
  onDismiss,
}) => ReactDOM.createPortal(
  <div className="cancel-confirm-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="cancel-confirm-title">
    <div className="cancel-confirm-modal">
      <div className="cancel-confirm-modal__header">
        <h3 id="cancel-confirm-title" className="cancel-confirm-modal__title">{message}</h3>
        <button
          type="button"
          className="cancel-confirm-modal__close"
          aria-label="Close"
          onClick={onDismiss}
        >
          &#x2715;
        </button>
      </div>
      {subtext && <p className="cancel-confirm-modal__subtext">{subtext}</p>}
      <hr className="cancel-confirm-modal__divider" />
      <div className="cancel-confirm-modal__footer">
        <button
          type="button"
          className="cancel-confirm-modal__btn cancel-confirm-modal__btn--cancel"
          onClick={onDismiss}
        >
          {noLabel}
        </button>
        <button
          type="button"
          className="cancel-confirm-modal__btn cancel-confirm-modal__btn--confirm"
          onClick={onConfirm}
        >
          {yesLabel}
        </button>
      </div>
    </div>
  </div>,
  document.body
)

export default CancelConfirmModal